import { render } from "./MyWithdraw.vue?vue&type=template&id=5496d6e5&scoped=true"
import script from "./MyWithdraw.vue?vue&type=script&lang=js"
export * from "./MyWithdraw.vue?vue&type=script&lang=js"

import "./MyWithdraw.vue?vue&type=style&index=0&id=5496d6e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5496d6e5"]])

export default __exports__